(function () {
  var DAY_MS = 24 * 60 * 60 * 1000;
  var CYCLE_DAYS = 2;
  var formatters = {};
  var STYLE_URL = 'https://cdn.shopify.com/s/files/1/0565/7080/6458/t/74/assets/product-art.css?v=1786431990';

  function ensureStyles() {
    if (document.querySelector('link[href*="/assets/product-art.css"]')) return;
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = STYLE_URL;
    stylesheet.setAttribute('data-sale-countdown-styles', '');
    document.head.appendChild(stylesheet);
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function dateParts(date, timeZone) {
    var formatter = formatters[timeZone];
    if (!formatter) {
      formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
      formatters[timeZone] = formatter;
    }
    return formatter.formatToParts(date).reduce(function (parts, part) {
      if (part.type !== 'literal') parts[part.type] = parseInt(part.value, 10);
      return parts;
    }, {});
  }

  function dayNumber(year, month, day) {
    return Math.floor(Date.UTC(year, month - 1, day) / DAY_MS);
  }

  function localMidnightUtc(year, month, day, timeZone) {
    var targetAsUtc = Date.UTC(year, month - 1, day, 0, 0, 0);
    var guess = targetAsUtc;
    for (var attempt = 0; attempt < 4; attempt += 1) {
      var parts = dateParts(new Date(guess), timeZone);
      var renderedAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      guess += targetAsUtc - renderedAsUtc;
    }
    return guess;
  }

  function cycleEnd(now, timeZone, anchorDate) {
    var nowParts = dateParts(now, timeZone);
    var anchor = anchorDate.split('-').map(Number);
    var today = dayNumber(nowParts.year, nowParts.month, nowParts.day);
    var anchorDay = dayNumber(anchor[0], anchor[1], anchor[2]);
    var elapsedDays = today - anchorDay;
    var cycleDay = ((elapsedDays % CYCLE_DAYS) + CYCLE_DAYS) % CYCLE_DAYS;
    var targetDayNumber = today + (CYCLE_DAYS - cycleDay);
    var targetDate = new Date(targetDayNumber * DAY_MS);
    return localMidnightUtc(
      targetDate.getUTCFullYear(),
      targetDate.getUTCMonth() + 1,
      targetDate.getUTCDate(),
      timeZone
    );
  }

  function initialise(countdown) {
    if (countdown.getAttribute('data-countdown-initialised') === 'true') return;
    countdown.setAttribute('data-countdown-initialised', 'true');
    var timeZone = countdown.getAttribute('data-time-zone') || 'America/New_York';
    var anchorDate = countdown.getAttribute('data-anchor-date') || '2026-01-01';
    var daysNode = countdown.querySelector('[data-countdown-days]');
    var hoursNode = countdown.querySelector('[data-countdown-hours]');
    var minutesNode = countdown.querySelector('[data-countdown-minutes]');
    var secondsNode = countdown.querySelector('[data-countdown-seconds]');

    function render() {
      var now = new Date();
      var remaining = Math.max(0, cycleEnd(now, timeZone, anchorDate) - now.getTime());
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysNode) daysNode.textContent = pad(days);
      if (hoursNode) hoursNode.textContent = pad(hours);
      if (minutesNode) minutesNode.textContent = pad(minutes);
      if (secondsNode) secondsNode.textContent = pad(seconds);
      countdown.setAttribute('data-countdown-ready', 'true');
    }

    render();
    window.setInterval(render, 1000);
  }

  function mountFallback() {
    if (document.querySelector('[data-sale-countdown]')) return;
    var template = document.querySelector('template[data-sale-countdown-fallback]');
    var priceSummary = document.querySelector('.ever-price-summary');
    if (!priceSummary) return;
    var productMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    var saleHandles = [
      'sage-green-classic-square-panel-wall-mural-wallpaper',
      'green-misty-forest-mural-wallpaper',
      'enchanted-forest-bath-mural-wallpaper',
      'union-jack-flag-wall-murals',
      'neutral-texture-mural-wallpaper',
      'overlooking-london-photo-murals',
      'colorless-bloom-vintage-flower-mural-idea-room-decor'
    ];
    var handle = productMatch ? productMatch[1] : '';
    if (!priceSummary.classList.contains('is-on-sale') || saleHandles.indexOf(handle) === -1) return;
    ensureStyles();
    var countdown;
    if (template && template.content && template.content.firstElementChild) {
      countdown = template.content.firstElementChild.cloneNode(true);
    } else {
      countdown = document.createElement('div');
      countdown.className = 'ever-sale-countdown';
      countdown.setAttribute('data-sale-countdown', '');
      countdown.setAttribute('data-time-zone', 'America/New_York');
      countdown.setAttribute('data-anchor-date', '2026-01-01');
      countdown.setAttribute('aria-label', '30% off sale countdown, anchored to US Eastern midnight');
      countdown.innerHTML =
        '<div class="ever-sale-countdown__heading">' +
          '<span class="ever-sale-countdown__badge">30% OFF</span>' +
          '<span class="ever-sale-countdown__title"><i aria-hidden="true"></i>Offer ends in</span>' +
        '</div>' +
        '<div class="ever-sale-countdown__timer" role="timer" aria-live="off">' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-days>00</strong><small>Days</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-hours>00</strong><small>Hrs</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-minutes>00</strong><small>Min</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-seconds>00</strong><small>Sec</small></span>' +
        '</div>';
    }
    priceSummary.classList.add('has-sale-countdown');
    priceSummary.insertAdjacentElement('afterend', countdown);
  }

  function start() {
    mountFallback();
    document.querySelectorAll('[data-sale-countdown]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
